module.exports = __webpack_public_path__ + "static/media/helicopter.6f58cd53.svg";